<template>
    <div>
        <div v-if="isLoading">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
            <app-form v-bind:parentObject="{
                data: this.formData,
                searchnew: this.search,
                pageTitle: this.pageTitle,
                pageTitleValue: this.formData.simulationcode,
                errMsg: this.errMsg,
                isEdit: this.isEdit,
                pmRewardBasicSalaryDetailList: this.pmRewardBasicSalaryDetailList,
                pmRewardBonusDetailList: this.pmRewardBonusDetailList,
                pmRewardBonusPostingInstrucDetailList: this.pmRewardBonusPostingInstrucDetailList,
                pmRewardInstruction: this.pmRewardInstruction,
                pmRewardInstructionIsEdit: this.pmRewardInstructionIsEdit,
                pmRewardSalaryPostingInstruc: this.pmRewardSalaryPostingInstruc,
                pmRewardSalaryPostingInstrucIsEdit: this.pmRewardSalaryPostingInstrucIsEdit
            }" v-on:input="formData = $event" v-on:save="saveHandler" v-on:error="errorHandler" />

            <div v-if="isErr">
                <app-error v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }" v-on:closeError="isErr = $event" />
            </div>
            <!-- <div v-if="isConfirm">
                <app-confirm
                v-bind:parentObject="{
                    pageTitleValue: this.pageTitleValue,
                    isConfirm: this.isConfirm,
                }"
                v-on:confirm="deleteHandler($event)"
                v-on:cancelConfirm="isConfirm = !isConfirm"
            />
            </div> -->
        </div>
    </div>
</template>

<script>
import PMRewardRecordForm from "../../../components/performance/reward/Form";
import moment from 'moment';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    components: {
        "app-form": PMRewardRecordForm,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            id: this.$route.params.id,
            search: this.$route.params.search,
            pageTitle: this.$t('pmrewardrecord.editsimulationrecord'),
            pageTitleValue: null,
            formData: {
                id: null,
                simulationcode: null,
                simulationdesc: null,
                assessmentrecordid: null,
                statusid: null,
                isfinalrecord: null,
                currencyid: null,

                stamp: null,
                updatedby: this.$store.getters.userId,
                
                //read only,4 column
                startdate: null,
                enddate: null,
                assessmentcode: null,
                currencycode: null,
            },
            errMsg: "",
            isErr: false,
            isLoading: true,
            isEdit: true,
            //isConfirm: false,

            //CRUD Table
            pmRewardBasicSalaryDetailList: [],
            pmRewardBonusDetailList: [],
            pmRewardBonusPostingInstrucDetailList: [],

            //Sub-Form
            pmRewardInstruction: null,
            pmRewardInstructionIsEdit: false,
            pmRewardSalaryPostingInstruc: null,
            pmRewardSalaryPostingInstrucIsEdit: false,

        };
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        async saveHandler() {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                return false;
            }

            try {
                const res = await this.$store.dispatch('put', {
                    url: "/pmrewardrecord/" + vm.id,
                    payload: this.formData
                });

                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    this.$router.push({ name: "pmrewardrecordlist" });
                }

            } catch (err) {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            }
        },

        async loadPMRewardRecordHandler() {
            this.isErr = false;
            this.errMsg = "";

            try {
                const res = await this.$store.dispatch('get', { url: `/pmrewardrecord/${this.id}` });

                if (res.status === 200 && res.data.rec) {
                    this.formData = { ...res.data.rec };
              
                } else {
                    this.isErr = true;
                    console.error("Reward record not found");
                    this.errMsg = "Reward record not found.";
                }
            } catch (err) {
                console.error("Error loading reward record:", err);
                this.isErr = true;
                this.errMsg = err.message || "Network Error";
            }
        },

        async loadPmRewardBasicSalaryIncre() {
            try {
                const res = await this.$store.dispatch('get', { url: "/pmrewardbasicsalaryincres/" + this.id });
                this.pmRewardBasicSalaryDetailList = res.data.rec;
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
            }
        },

        async loadPmRewardBonus() {
            try {
                const res = await this.$store.dispatch('get', { url: "/pmrewardbonus/" + this.id });
                this.pmRewardBonusDetailList = res.data.rec;
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
            }
        },

        async loadPmRewardBonusPostingInstruc() {
            try {
                const res = await this.$store.dispatch('get', { url: "/pmrewardbonuspostinginstruc/" + this.id });
                this.pmRewardBonusPostingInstrucDetailList = res.data.rec;
                this.pmRewardBonusPostingInstrucDetailList.forEach(item => {
                    if (item.effectivedate) {
                        item.effectivedate = moment(item.effectivedate).format('YYYY-MM-DD');
                    }
                });
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
            }
        },

        async loadPmRewardInstruction() {
            try {
                const res = await this.$store.dispatch('get', { url: "/pmrewardinstruction/" + this.id });
                this.pmRewardInstruction = res.data.rec;
               
                if(this.pmRewardInstruction) {
                    this.pmRewardInstructionIsEdit = true;
                    this.pmRewardInstruction.basicsalarydate = moment(this.pmRewardInstruction.basicsalarydate).format('YYYY-MM-DD');
                    this.pmRewardInstruction.staffdetailsdate = moment(this.pmRewardInstruction.staffdetailsdate).format('YYYY-MM-DD');
                    this.pmRewardInstruction.hirebeforedate = moment(this.pmRewardInstruction.hirebeforedate).format('YYYY-MM-DD');
                    this.pmRewardInstruction.cessatecutoffdate = moment(this.pmRewardInstruction.cessatecutoffdate).format('YYYY-MM-DD');
                } else {
                    this.pmRewardInstructionIsEdit = false;//then we can create at the form later
                }
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
            }
        },

        async loadPmRewardSalaryPostingInstruc() {
            try {
                const res = await this.$store.dispatch('get', { url: "/pmrewardsalarypostinginstruc/" + this.id });
                this.pmRewardSalaryPostingInstruc = res.data.rec;
               
                if(this.pmRewardSalaryPostingInstruc) {
                    this.pmRewardSalaryPostingInstrucIsEdit = true;
                    this.pmRewardSalaryPostingInstruc.recdate = moment(this.pmRewardSalaryPostingInstruc.recdate).format('YYYY-MM-DD');
                    if(this.pmRewardSalaryPostingInstruc.actualeffectivedate) {
                        this.pmRewardSalaryPostingInstruc.actualeffectivedate = moment(this.pmRewardSalaryPostingInstruc.actualeffectivedate).format('YYYY-MM-DD');
                    }
                } else {
                    this.pmRewardSalaryPostingInstrucIsEdit = false;//then we can create at the form later
                }
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
            }
        },
    },

    async mounted() {
        try {
            await this.loadPMRewardRecordHandler();
            await this.loadPmRewardBasicSalaryIncre();
            await this.loadPmRewardBonus();
            await this.loadPmRewardBonusPostingInstruc();
            await this.loadPmRewardInstruction();
            await this.loadPmRewardSalaryPostingInstruc();

            this.isLoading = false; // Set loading to false after all data is loaded
        } catch (error) {
            console.error("Something went wrong during mounted:", error);
            this.isErr = true;
            this.errMsg = error;
        }
    }
};
</script>